import React from 'react'
import FormSelect from 'components/forms/bases/FormSelect'

const FontStyleSelector = ({
  value,
  onChange,
}) => {
  return (
    <FormSelect
      label="Style"
      value={value || 'normal'}
      onChange={onChange}
      options={
        [
          'normal',
          'italic',
          'oblique'
        ]
      }
    />
  )
}

FontStyleSelector.propTypes = {}
FontStyleSelector.defaultProps = {}

export default FontStyleSelector



// WEBPACK FOOTER //
// ./src/components/forms/FontStyleSelector.js